import {
  RESET_NEW_MEMBER_PAGE,
  SET_NEW_MEMBER_PAGE_ERROR,
  SET_PAGE_STATUS,
  SET_IS_USER_DATA_CHANGED_VALUE,
  SET_EDITED_PROVIDER_MEMBER_DATA_VALUE,
  SET_EDITED_ADMIN_MEMBER_DATA_VALUE,
} from './newMemberConstants'

export function resetNewMemberState() {
  return {
    type: RESET_NEW_MEMBER_PAGE,
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setPageStatus(newStatus) {
  return {
    type: SET_PAGE_STATUS,
    payload: newStatus,
  }
}

export function setError(code = '', extra = null) {
  return {
    type: SET_NEW_MEMBER_PAGE_ERROR,
    payload: { UserFriendlyErrorCode: code, extra },
  }
}

export function setIsUserDataChangedValue(newStatus = false) {
  return {
    type: SET_IS_USER_DATA_CHANGED_VALUE,
    payload: newStatus,
  }
}

export function setEditedProviderMemberDataValue(value = null) {
  return {
    type: SET_EDITED_PROVIDER_MEMBER_DATA_VALUE,
    payload: value,
  }
}

export function setEditedAdminMemberDataValue(value = null) {
  return {
    type: SET_EDITED_ADMIN_MEMBER_DATA_VALUE,
    payload: value,
  }
}
